import { RouterStore } from 'mobx-react-router';
import { authStore, appStore } from 'stores'
import { loginStore } from 'modules/login';
import { paperworkEntryStore } from 'modules/paperwork-entry';

class RootStore {
    constructor() {
        this.routerStore = new RouterStore();
        this.authStore = authStore;
        this.appStore = appStore;
        this.paperworkEntryStore = paperworkEntryStore;
        this.loginStore = loginStore;

        this.reset = this.reset.bind(this);
    }

    reset() {
        if (this.authStore.reset)
            this.authStore.reset();
        if (this.appStore.reset)            
            this.appStore.reset();
        if (this.paperworkEntryStore.reset)
            this.paperworkEntryStore.reset();
        if (this.loginStore.reset)
            this.loginStore.reset();
    }
}

export { RootStore };


// WEBPACK FOOTER //
// ./src/stores/rootStore.js